export default "* Ofring\n* Ceremoni\n* Ånder\n* Shaman";